import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    items: []
  },
  mutations: {
    setItems (state, list) {
      state.items = list
    }
  },
  getters: {

  },
  actions: {
    get ({ commit, state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.favlist(token, data)
            .then((res) => {
              commit('setItems', res.body)
              resolve(state.items)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    add ({ commit, state, dispatch }, inflluencerId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.favlistAdd(token, { influencer_id: inflluencerId })
            .then((res) => {
              dispatch('get')
              resolve(true)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    delete ({ commit, state, dispatch }, inflluencerId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.favlistDelete(token, inflluencerId)
            .then((res) => {
              dispatch('get')
              resolve(true)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
